const hook = {
    missing_events: 'Sie müssen mindestens ein Ereignis angeben.',
    send_test_payload_failed: 'Fehler beim Senden des Testpayloads: {{message}}',
    endpoint_responded_with_error: 'Endpunkt antwortete mit Fehler.',
};
export default Object.freeze(hook);
